class DashboardResponse {
    constructor({
                    body = '',
                    fileId = '',

                } = {}) {
        this.body= body;
        this.fileId = fileId;
    }    
}
export default DashboardResponse;